import React from "react"
import { graphql, useStaticQuery, navigate } from "gatsby"

import { makeStyles } from '@material-ui/core/styles';

import { GoogleApiWrapper, Marker, Map } from "google-maps-react";
import MapInfoWindow from "./map-infowindow";

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';

import pointConfig from '../point-config'

import { connect } from 'react-redux'
import { updateRecentAreaId } from '../store/app'

const useStyles = makeStyles((theme) => ({
  pointButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  item: {
    marginTop: theme.spacing(1),
  },
}));

export const GoogleMapComponent = ( props ) => {

  const data = useStaticQuery(graphql`
    query GoogleMapComponentQuery {
      yatt: file(absolutePath: { regex: "/yatt.png/" }) {
        childImageSharp {
          fluid(maxWidth: 120) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  const yatt = data?.yatt?.childImageSharp?.fluid?.src

  const google = props.google;
  // store
  const dispatch = props.dispatch;
  const recentAreaId = props.recentAreaId;
  const url = props.location.origin;

  const classes = useStyles();

  const defaultLocation = { lat: 35.212, lng: 135.5412 };
  const [showingInfoWindow, setShowingInfoWindow] = React.useState(false)
  const [activeMarker, setActiveMarker] = React.useState({})
  const [selectedPlace, setSelectedPlace] = React.useState({})
  const [location, setLocation] = React.useState(defaultLocation)
  const [selectedItem, setSelectedItem] = React.useState({})
  const [isPoint, setIsPoint] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    if (recentAreaId !== false && pointConfig[recentAreaId]) {
      setLocation(pointConfig[recentAreaId].location);
      setSelectedItem(pointConfig[recentAreaId])
      setIsPoint(true)
    }
    else {
      // 現在置 取得
      navigator.geolocation.getCurrentPosition((position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      },
      (err) => {
        console.log(err);
      });
    }

  }, []);

  const onMarkerClick = (props, marker, e) => {
    if (isPoint === true) {
      console.log(selectedItem)
    }
    else {
      dispatch(updateRecentAreaId(props.id));
      setSelectedItem(pointConfig[props.id]);
    }
    setLocation(props.position)
    setSelectedPlace(props);
    setActiveMarker(marker);
    setShowingInfoWindow(true);
  }

  const onMapClicked = (props) => {
    if (showingInfoWindow) {
      setShowingInfoWindow(false);
      setActiveMarker(null);
    }
  };

  const onChoiceArea = (e) => {
    e.preventDefault();
    setIsPoint(true);
    if (showingInfoWindow) {
      setShowingInfoWindow(false);
      setActiveMarker(null);
    }
  };

  const onRemoveArea = () => {
    setIsPoint(false);
    dispatch(updateRecentAreaId(false))
    if (showingInfoWindow) {
      setShowingInfoWindow(false);
      setActiveMarker(null);
    }
  }

  const toAreaContent = () => {
    setIsLoading(true);
    navigate(`/content/${selectedItem.id}`);
  }

  const toPointContent = () => {
    setIsLoading(true);
    navigate(`/content/${selectedPlace.id}`);
  }

  const createMarinLink = () => {
    console.log(selectedPlace)
    if (selectedPlace.areaId === undefined) {
      return
    }
    else {
      const nagasakiOnlyLink = <React.Fragment>
          <br />
          <Link href="https://www.kaiho.mlit.go.jp/07kanku/sasebo/tyouseki/2021hario.pdf" target="_blank" rel="noreferrer" color="primary">
            針尾瀬戸潮流情報へ
          </Link>
        </React.Fragment>

      if (selectedPlace.linkTitle && selectedPlace.link) {
        return <div>
          <Link href={selectedPlace.link} target="_blank" rel="noreferrer" color="primary">
            {selectedPlace.linkTitle}へ
          </Link>
          {selectedPlace.areaId === "007" ? nagasakiOnlyLink : ""}
        </div>
      }
      else {
        return <div>
          <Link href={pointConfig[selectedPlace.areaId].link} target="_blank" rel="noreferrer" color="primary">
            {pointConfig[selectedPlace.areaId].linkName}へ
          </Link>
          {selectedPlace.areaId === "007" ? nagasakiOnlyLink : ""}
        </div>
      }
    }
  }

  return (
    <div style={{ width: `100%`, height: `100vh` }}>
      { isLoading && <LinearProgress /> }
      <Map
        google={google}
        zoom={isPoint === false ? 5.4 : 8.5}
        center={{ lat: location.lat, lng: location.lng }}
        initialCenter={{ lat: location.lat, lng: location.lng }}
        onClick={onMapClicked}
      >
        { isPoint === false ? (
          Object.keys(pointConfig).map(k => {
            const v = pointConfig[k];
            return (
              <Marker
                key={`marker-${k}`}
                name={v.name}
                position={{ lat: v.location.lat, lng: v.location.lng }}
                id={k}
                areaId={k}
                onClick={onMarkerClick}
                icon={{
                  url: `${url}${yatt}`,
                  anchor: new google.maps.Point(16,16),
                  scaledSize: new google.maps.Size(32,32)
                }}
              />
            )
          })
        ) : (
          Object.keys(pointConfig).map(key => {
            const value = pointConfig[key];
            return Object.keys(value.items).map(k => {
              const v = value.items[k];
              return (
                <Marker
                  key={`marker-${k}`}
                  name={v[0]}
                  position={{ lat: v[1], lng: v[2] }}
                  id={k}
                  areaId={v[12]}
                  onClick={onMarkerClick}
                  link={v[14]}
                  linkTitle={v[13]}
                />
              )
            })
          })
          /*
          Object.keys(pointConfig).map(k => {
            const v = pointConfig[k];
            Object.keys(v.items).map(a => {
              console.log(a)
              const d = v.items[a];
              console.log(d);
              return (
                <Marker
                  key={`marker-${a}`}
                  name={d[0]}
                  position={{ lat: d[1], lng: d[2] }}
                  id={a}
                  onClick={onMarkerClick}
                />
              )
            })
          })*/
        )}
        <MapInfoWindow
          marker={activeMarker}
          visible={showingInfoWindow}
        >
          <Grid container align="center" alignItems="center" justify="center">
            <Grid item xs={12}>
              <Typography variant="h6" component="p">
                {selectedPlace.name}
              </Typography>

              {isPoint === false ? (
                <Button onClick={onChoiceArea} variant="outlined" edge="start" className={classes.pointButton} color="primary" aria-label="point">
                  ポイント選択へ
                </Button>
              ) : (
                <Button onClick={toPointContent} variant="outlined" edge="start" className={classes.pointButton} color="primary" aria-label="point">
                  このポイントの気象情報へ
                </Button>
              )}

              <Grid
                container
                direction="column"
                justify="space-between"
                alignItems="flex-end"
              >
                <Grid item className={classes.item}>
                  <Typography variant="inherit" component="p">
                    {isPoint === false ? (
                      <Link onClick={toAreaContent} color="primary">
                        このエリアの気象情報へ
                      </Link>
                    ) : (
                      <Link onClick={onRemoveArea} color="primary">
                        マリーナ一覧に戻る
                      </Link>
                    )}
                  </Typography>
                </Grid>
                <Grid item className={classes.item}>
                  <Typography variant="inherit" component="p" align="right">
                    {createMarinLink()}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MapInfoWindow>
      </Map>
    </div>
  );
}

const googleWrapper = GoogleApiWrapper({
  apiKey: process.env.GATSBY_GOOGLE_MAP_API_KEY
})(GoogleMapComponent)

export default connect(state => ({
  recentAreaId: state.app.recentAreaId
}), null)(googleWrapper)